import React, { memo, useEffect, useState } from "react";

import darkLogo from "../../../assets/images/logo-dark.png";

import { useDispatch, useSelector } from "react-redux";
import { getAllCategoryAction, getFooterAction } from "../../../redux/actions";
import { useLocation, Link, withRouter, useParams } from "react-router-dom";
import { getImageUrl } from "../../../utils";
import ReactGA from "react-ga";
import Macro from "../../../utils/ReplaceMacro";
import UpdateDateMacrosInString from "../../UI/UpdateDateMacrosInString";

const Footer = ({ location, match }) => {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const { domainData } = useSelector((state) => state.Website);
  const { storesList } = useSelector((state) => state.Stores);

  let activeStoresList = storesList?.filter(
    (ele) => ele.is_archived === false && ele.is_paused === false
  );

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  window.addEventListener("scroll", toggleVisible);
  const {
    Category: { categoryList },
  } = useSelector((state) => state);

  const isEmailAvailable = Boolean(domainData?.contact?.email);
  const isPhoneAvailable = Boolean(domainData?.contact?.phone);
  const isAddressAvailable = Boolean(domainData?.contact?.address);

  useEffect(() => {
    function set() {
      ReactGA.initialize("UA-200647590-1");
      ReactGA.pageview(location.pathname + location.search);
    }
    set();
  }, [location]);

  useEffect(() => {
    function fetch() {
      dispatch(getAllCategoryAction());
      dispatch(getFooterAction());
    }
    fetch();
  }, [dispatch]);

  return (
    <div
      className={`footer footer-root`}
      style={{ "--footer-accent": domainData?.header_color }}
    >
      <div className="home2-inner-footer">
        <div id="foot-logo-h3" className="home2-footer-items footer-logo-section">
          <Link to="/">
            <img
              src={getImageUrl(domainData?.logo, darkLogo)}
              alt=""
              className="img-responsive logo footer-logo-img"
              id="h2-foot-logo"
            />
          </Link>
          <Link to="/aboutus">
            <p style={{ color:"#7d8693" }} className="footer-about">{domainData?.footer_about_us}</p>
          </Link>
          <Link to="/privacypolicy">
            <span>
              <strong style={{ color:"#7d8693", fontWeight:"bold" }}>Privacy Policy</strong>
            </span>
          </Link>
          {/*   Footer Bottom start  */}
          <div style={{ color:"#7d8693" }} className="footer-bottom-text">
            <Macro input={domainData?.footer_text} />
          </div>
        </div>
        {activeStoresList && activeStoresList.length > 0 && <div className="home2-footer-items">
          <h3>Common Stores</h3>
          <div className="border1" />
          <ul className="tags">
            {activeStoresList?.slice(0, 10).map((store) => (
                <li key={store.slug}>
                  <a
                    href={`/store/${store?.slug}`}
                    // onClick={(e) => {
                    //   e.preventDefault();
                    //   history.push({
                    //     pathname: `/store/${store?.slug}`,
                    //     state: { store },
                    //   });
                    // }}
                    className="tag"
                  >
                    <UpdateDateMacrosInString input={store?.name} />
                  </a>
                </li>
              ))}
          </ul>
        </div>}
        {categoryList.length > 0 && <div className="home2-footer-items">
          <h3>Categories</h3>
          <div className="border1" />
          <ul className="footer-ul">
            {categoryList?.slice(0, 5).map((el) => {
              return (
                <li
                  className="category"
                >
                  <Link to={`/category/${el.category}`}>
                    {el.category}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>}
        {/*  for contact us info */}
        {(isAddressAvailable || isEmailAvailable || isPhoneAvailable) && <div className="home2-footer-items footer-contact-section">
          <h3>Contact us</h3>
          <div className="border1 border1-accent" />
          <ul className="footer-contact-list">
            {isAddressAvailable && (
              <li className="contact-item">
                <i className="fa fa-map-marker" aria-hidden="true" />
                <span>{domainData?.contact?.address}</span>
              </li>
            )}
            {isPhoneAvailable && (
              <li className="contact-item">
                <i className="fa fa-phone" aria-hidden="true" />
                <span>{domainData?.contact?.phone}</span>
              </li>
            )}
            {isEmailAvailable && (
              <li className="contact-item">
                <i className="fa fa-envelope" aria-hidden="true" />
                <span>{domainData?.contact?.email}</span>
              </li>
            )}
          </ul>
        </div>}
      </div>
      <button
        id="show-code"
        className={`btn btn-success footer-show-code ${visible ? "visible" : ""}`}
        title="Scroll to top"
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
};

export default memo(withRouter(Footer));
